import React, {useContext} from "react";
import {MarketItem} from "@interfaces/user/market";

const MarketItemContext = React.createContext<MarketItem>(undefined as any);
export const MarketItemProvider = MarketItemContext.Provider;

export function useMarketItemContext(): MarketItem | undefined {
    return useContext(MarketItemContext);
}